<template>
  <div v-loading="$wait.waiting(_uid)" class="card training-program">
    <div class="card-content">
      <div class="row mt-s">
        <ProgramTable :data="program" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ProgramTable from "@/components/Dashboard/Views/Pages/Training/Components/ProgramTable";

export default {
  components: {
    ProgramTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", ["user", "program"]),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getUsersProgram(this.user.id);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("companyUserStore", ["getUsersProgram"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>

<style lang="scss"></style>
